import { render, staticRenderFns } from "./CategoriasUpdate.vue?vue&type=template&id=6d66b8e2&"
import script from "./CategoriasUpdate.vue?vue&type=script&lang=js&"
export * from "./CategoriasUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports